import asyncThunk from '@/lib/asyncThunk'
import { Invitation } from '@/out/invitation'

export type Request = Record<never, never>

export const listInvitations = asyncThunk<Request, Invitation[]>({
  name: 'invitations/list',
  uri: '/invitations',
})
